declare global {
   interface Window {
      fireGlobal?: typeof fireGlobal;
      listenGlobal?: typeof listenGlobal;
   }
}

const handlers: Record<string, ((...args: any[]) => void)[]> = {};

/**
 * Fire an event globally so that listeners can be set up before any class
 * is defined.
 */
export function fireGlobal(eventName: string, ...args: any[]): void {
   (handlers[eventName] || []).forEach(fn => fn(...args));
}

/**
 * Listen to an event globally so that listeners can be set up before any class
 * is defined.
 */
export function listenGlobal(eventName: string, handler: (...args: any[]) => void): void {
   (handlers[eventName] ||= []).push(handler);
}

// Installed iFixit app builds call the bare listenGlobal('login.success') to close
// their login screen (iFixit/expo utils/webview-scripts/auth-events.webview.js).
if (typeof window !== 'undefined') {
   window.fireGlobal = fireGlobal;
   window.listenGlobal = listenGlobal;
}
